import React from 'react'

import HeaderNew from 'presentation/shared/components/HeaderNew'
import AddPatientDefault from 'presentation/doctor/components/Forms/AddPatientDefault'

const AddPatientDefaultLayout = () => {
  return (
    <>
      <HeaderNew actualPageTitle="Cadastrar novo paciente" />
      <AddPatientDefault />
    </>
  )
}

export default AddPatientDefaultLayout
